import React from 'react';

import { File, FileText, Film, Image, Music } from 'lucide-react';

export function getFileIcon(type: string): React.ReactElement {
  if (type.startsWith('image/')) return <Image size={20} />;
  if (type.startsWith('video/')) return <Film size={20} />;
  if (type.startsWith('audio/')) return <Music size={20} />;
  if (type.includes('pdf') || type.includes('document'))
    return <FileText size={20} />;
  return <File size={20} />;
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
